import { render } from "./FooterServiceMenue.vue?vue&type=template&id=2a3cd13f"
import script from "./FooterServiceMenue.vue?vue&type=script&lang=js"
export * from "./FooterServiceMenue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__